import apiClient from './apiClient';
import { UserType } from '../types/userType';

interface UserResponse {
  data: UserType;
}

export const fetchUserByUsername = async (username: string): Promise<UserType> => {
  try {
    const response = await apiClient.get<UserResponse>(`/core/users/${username}/`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching user by username:', error);
    throw error;
  }
};

export const fetchUserShippingInfo = async (username: string) => {
  try {
    const response = await apiClient.get(`/core/users/${username}/shipping/`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching user shipping info:', error);
    throw error;
  }
};

interface PostsResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: Array<any>; // You can type this more specifically based on your PostProps
}

export const fetchPostsByUser = async (username: string, page: number = 1, pageSize: number = 30): Promise<PostsResponse> => {
  try {
    const response = await apiClient.get(`/core/user/${username}/posts/`, {
      params: {
        page,
        page_size: pageSize
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching user posts:', error);
    throw error;
  }
};

export const updateProfilePicture = async (username: string, profileImage: File): Promise<void> => {
  try {
    const formData = new FormData();
    formData.append('profile_picture', profileImage);

    await apiClient.put(`/core/user/${username}/profile_picture/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  } catch (error) {
    console.error('Error updating profile picture:', error);
    throw error;
  }
};
